import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * On every SPA navigation:
 *  - if the URL has a #hash, smooth-scroll to that exact element (anchor links);
 *  - otherwise, jump the window back to the top of the new page.
 * Applies globally to all B2C and B2B routes.
 */
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const id = hash.replace("#", "");
      // Retry a few times: the target may render after the page transition.
      let tries = 0;
      const tick = () => {
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({ behavior: "smooth", block: "start" });
        } else if (tries++ < 10) {
          setTimeout(tick, 60);
        }
      };
      tick();
      return;
    }
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname, hash]);

  return null;
}
